/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FormatStrikethroughIcon
 */
export default class FormatStrikethroughIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12.8 2.2c1 0 1.908.07 2.725.212.817.142 1.462.329 1.812.59.35.26.391.905.138 1.248-.265.358-.865.408-1.8.15-.417-.1-.875-.183-1.375-.25s-1.033-.1-1.6-.1a5.14 5.14 0 00-1.487.2 3.714 3.714 0 00-1.125.537 2.447 2.447 0 00-.713.788c-.167.3-.25.617-.25.95 0 .65.23 1.192.688 1.625.458.433 1.029.82 1.712 1.162.683.342 1.425.68 2.225 1.013.49.204.959.429 1.405.674L20 11c.6 0 1 .4 1 1s-.4 1-1 1l-2.373-.001.06.076c.413.555.64 1.232.681 2.03l.007.27c0 .75-.137 1.425-.413 2.025a4.453 4.453 0 01-1.174 1.55c-.509.433-1.134.767-1.876 1-.741.233-1.579.35-2.512.35-.633 0-1.233-.05-1.8-.15a12.29 12.29 0 01-1.563-.375c-.475-.15-.574-.15-1.275-.475-.7-.325-.932-.971-.616-1.538.317-.566 1.066-.474 1.604-.237.538.238 1.063.488 1.688.663a6.97 6.97 0 001.887.262c.55 0 1.067-.054 1.55-.162a3.67 3.67 0 001.262-.526c.359-.241.642-.545.85-.912.209-.367.313-.8.313-1.3 0-.683-.23-1.242-.688-1.675A6.334 6.334 0 0014.419 13H4c-.6 0-1-.4-1-1s.4-1 1-1h6.083c-.216-.12-.427-.244-.633-.375a6.247 6.247 0 01-1.712-1.588c-.459-.625-.688-1.42-.688-2.387 0-.683.138-1.3.413-1.85a4 4 0 011.162-1.4c.5-.383 1.104-.68 1.813-.887.708-.209 1.495-.313 2.362-.313z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

